import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styles from "./promptsAddEdit.module.css";
import { DialogContent, DialogTitle, TextField } from "@mui/material";
import { ArrowLeft, X } from "react-feather";
import { useEffect } from "react";
const schema = yup.object().shape({
  title: yup.string().required("This field is Required").max(200, "Title cannot be more than 200 characters"),
  description: yup.string().required("This field is Required").max(700, "Description cannot be more than 700 characters")
});

const PromptAddEdit = (props) => {
  const { register, handleSubmit, control, errors, setValue, watch } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  useEffect(() => {
    if (props.promptDetails) {
      setValue("title", props.promptDetails.title);
      setValue("description", props.promptDetails.description);
    } else {
      setValue("title", "");
      setValue("description", "");
    }
  }, [props.promptDetails]);

  const onSubmit = (data) => {
    console.log(data);

    if (props.promptDetails) {
      props.updatePrompts(data);
    } else {
      props.AddPrompts(data);
    }
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
      <button className={`${styles.BackAddBU}`} onClick={() => props.handleAddEditForm(false)}>
        <ArrowLeft />
      </button>
      {props.promptDetails ? "Edit Prompt" : "Add Prompt"}
      <button onClick={(e) => props?.handleCloseModal(false)} className={`${styles.ModalCloseBU}`}>
        <X />
      </button>
    </DialogTitle>
    <DialogContent className={`${styles.RequestBodyPop}`}>
      <div className={`${styles.PromptAddEditSec}`}>
        <form id="myForm" onSubmit={handleSubmit(onSubmit)}>
          {/* <div className={`${styles.FormGroup}`}>
              <label className={`${styles.FilterLabel}`}>
                Title<span className={`${styles.errorSpan}`}>*</span>
              </label>
              <input
                placeholder="Title"
                className={`${styles.formControl}`}
                name="title"
                ref={register}
              ></input>
              {errors.title && (
                <p className={`${styles.ErrorM}`}>{errors.title.message}</p>
              )}
            </div> */}

          <div className={`${styles.FormGroup} FormGroup`}>
            <Controller
              name={`title`}
              control={control}
              render={(field) => (<TextField
                {...field}
                label="Title*"
                variant="outlined"
                error={errors?.title}
              />)}
            />
            {errors.title && (<p className={`${styles.ErrorM}`}>{errors.title.message}</p>)}
          </div>
          {/* <div className={`${styles.FormGroup}`}>
              <label className={`${styles.FilterLabel}`}>
                Description<span className={`${styles.errorSpan}`}>*</span>
              </label>
              <textarea
                placeholder="Add text here..."
                className={`${styles.formControlTextArea}`}
                name="description"
                ref={register}
              ></textarea>
              {errors.description && (
                <p className={`${styles.ErrorM}`}>
                  {errors.description.message}
                </p>
              )}
            </div> */}

          <div className={`${styles.FormGroup} FormGroup`}>
            <Controller
              name={`description`}
              control={control}
              render={(field) => (<TextField
                {...field}
                label="Description*"
                variant="outlined"
                multiline
                rows={6}
                error={errors?.description}
              />)}
            />
            {errors.description && (<p className={`${styles.ErrorM}`}>{errors.description.message}</p>)}
          </div>
          <div className={`${styles.PromptAddEditButtonSec}`}>
            <button onClick={() => props.handleAddEditForm(false)} className={`${styles.PromptCancelBU}`}>Cancel</button>
            <button type="submit" className={`${styles.PromptAddBU}`}>{!props.promptDetails ? "Add" : "Update"}</button>
          </div>
        </form>
      </div>
    </DialogContent>
  </>);
};

export default PromptAddEdit;